

const session = {
  set: (keyValue, value) => {
    return sessionStorage.setItem(keyValue, value);
  },

  get: (keyValue) => {
    return sessionStorage.getItem(keyValue);
  },
};

const local = {
  set: (keyValue, value) => {
    return localStorage.setItem(keyValue, value);
  },

  get: (keyValue) => {
    return localStorage.getItem(keyValue);
  },
};

const genGetSetKeyLocal = (key) => ({
  get: () => local.get(key) ?? '',
  set: (value) => local.set(key, value),
});

const genGetSetKeySession = (key) => ({
  get: () => session.get(key) ?? '',
  set: (value) => session.set(key, value),
});

const storage = {
  get: session.get,
  set: session.set,
  genGetSetKeyLocal,
  genGetSetKeySession,
  tickets_filter: genGetSetKeyLocal('tickets_filter'),
};

export default storage;
